import axios from "axios";
export const dingLogin = params => {
  return axios.request({
    url: "/api/sso/dingtalk/login",
    method: "get",
    params
  });
};